/**
 * 📿 PENDANTS
 *
 * Pendant/necklace equipment items (10 total)
 * Level requirements: 10-80 (increments of ~10)
 * Stat requirements: LUK for crit items, INT for magical pendants
 *
 * Level Distribution:
 * - Common (2): Lv 10, 15
 * - Uncommon (2): Lv 25, 30
 * - Rare (2): Lv 40, 45
 * - Epic (2): Lv 55, 60
 * - Legendary (2): Lv 75, 85
 *
 * Note: Uses 'pendant1' slot in PlayerPanel
 */

export const PENDANTS = {
  // ============================================================
  // COMMON PENDANTS (2) - Lv 10, 15
  // ============================================================
  woodenPendant: {
    id: 'woodenPendant',
    name: 'Wooden Pendant',
    icon: '📿',
    slot: 'pendant1',
    rarity: 'common',
    levelReq: 10,
    requirements: {},
    description: 'A simple carved wooden pendant.',
    stats: {
      critChance: 0.01,
      health: 5,
    },
  },
  copperAmulet: {
    id: 'copperAmulet',
    name: 'Copper Amulet',
    icon: '💎',
    slot: 'pendant1',
    rarity: 'common',
    levelReq: 15,
    requirements: { LUK: 10 },
    description: 'A tarnished copper amulet.',
    stats: {
      critChance: 0.02,
      health: 8,
    },
  },

  // ============================================================
  // UNCOMMON PENDANTS (2) - Lv 25, 30
  // ============================================================
  silverAmulet: {
    id: 'silverAmulet',
    name: 'Silver Amulet',
    icon: '💎',
    slot: 'pendant1',
    rarity: 'uncommon',
    levelReq: 25,
    requirements: { LUK: 35 },
    description: 'A polished silver amulet.',
    stats: {
      critChance: 0.04,
      critDamage: 0.10,
      health: 15,
    },
  },
  jadePendant: {
    id: 'jadePendant',
    name: 'Jade Pendant',
    icon: '💚',
    slot: 'pendant1',
    rarity: 'uncommon',
    levelReq: 30,
    requirements: { LUK: 30, INT: 25 },
    description: 'A pendant carved from precious jade.',
    stats: {
      critChance: 0.05,
      critDamage: 0.08,
      health: 12,
    },
  },

  // ============================================================
  // RARE PENDANTS (2) - Lv 40, 45
  // ============================================================
  rubyAmulet: {
    id: 'rubyAmulet',
    name: 'Ruby Amulet',
    icon: '💎',
    slot: 'pendant1',
    rarity: 'rare',
    levelReq: 40,
    requirements: { LUK: 65 },
    description: 'A brilliant ruby set in gold.',
    stats: {
      critChance: 0.08,
      critDamage: 0.20,
      health: 25,
    },
  },
  sapphirePendant: {
    id: 'sapphirePendant',
    name: 'Sapphire Pendant',
    icon: '💙',
    slot: 'pendant1',
    rarity: 'rare',
    levelReq: 45,
    requirements: { LUK: 55, INT: 40 },
    description: 'A deep blue sapphire pendant.',
    stats: {
      critChance: 0.09,
      critDamage: 0.18,
      health: 28,
    },
  },

  // ============================================================
  // EPIC PENDANTS (2) - Lv 55, 60
  // ============================================================
  starCore: {
    id: 'starCore',
    name: 'Star Core',
    icon: '⭐',
    slot: 'pendant1',
    rarity: 'epic',
    levelReq: 55,
    requirements: { LUK: 100, INT: 50 },
    description: 'The core of a fallen star, still burning with power.',
    stats: {
      critChance: 0.12,
      critDamage: 0.35,
      health: 40,
    },
  },
  abyssalHeart: {
    id: 'abyssalHeart',
    name: 'Abyssal Heart',
    icon: '🖤',
    slot: 'pendant1',
    rarity: 'epic',
    levelReq: 60,
    requirements: { LUK: 90, INT: 60 },
    description: 'A heart torn from an abyssal creature.',
    stats: {
      critChance: 0.14,
      critDamage: 0.40,
      health: 35,
    },
  },

  // ============================================================
  // LEGENDARY PENDANTS (2) - Lv 75, 85
  // ============================================================
  heartOfInfinity: {
    id: 'heartOfInfinity',
    name: 'Heart of Infinity',
    icon: '💜',
    slot: 'pendant1',
    rarity: 'legendary',
    levelReq: 75,
    requirements: { LUK: 140, INT: 70 },
    description: 'Contains infinite power within its core.',
    stats: {
      critChance: 0.18,
      critDamage: 0.60,
      health: 70,
    },
  },
  voidEssencePendant: {
    id: 'voidEssencePendant',
    name: 'Void Essence Pendant',
    icon: '🌌',
    slot: 'pendant1',
    rarity: 'legendary',
    levelReq: 85,
    requirements: { LUK: 160, INT: 80 },
    description: 'Crystallized essence of the void itself.',
    stats: {
      critChance: 0.20,
      critDamage: 0.70,
      health: 60,
    },
  },
};
